import {anyPass, constant, defaultTo, equals, firstOf, flow, get, groupBy, ifThen} from '@yandex-delivery/utils'

import type {ImageWidgetConfig, SectionProps as Props, SlotWidgetConfig, WidgetConfig} from '../types'

type OptionWidgets = {
  requirements?: (SlotWidgetConfig | ImageWidgetConfig)[]
  banner?: SlotWidgetConfig[]
  children: SlotWidgetConfig[]
}
type OptionType = keyof OptionWidgets

const isRequirementsWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('widget_id'),
  anyPass([
    equals('body_size_images_widget'), //
    equals('body_size_widget'),
    equals('loaders_widget'),
    equals('cargo_c2c_order_forms_b2b_lk_walking_courier_description_1_information_slot_widget'),
    equals('cargo_c2c_order_forms_b2b_lk_walking_courier_description_2_information_slot_widget'),
  ]),
)
const isBannerWidget: (widget: SlotWidgetConfig) => boolean = flow(
  get('widget_id'),
  equals('cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget'),
)
const byWidgetId: (widget: WidgetConfig) => OptionType = flow(
  firstOf(
    ifThen(isRequirementsWidget, constant<OptionType>('requirements')),
    ifThen(isBannerWidget, constant<OptionType>('banner')),
  ),
  defaultTo<OptionType>('children'),
)

export const groupByWidgetId: (props: Props) => OptionWidgets = flow(
  get('section.widgets'), //
  groupBy(byWidgetId) as unknown as (w: WidgetConfig[]) => OptionWidgets,
)
